import { Link } from "gatsby";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import { LANGUAGE } from "../../../../company/settings/translations";
import { ILink } from "../../types/thecookies";
import { getSlugWithLang } from "../Shared/Utils/getSlugWithLang";
import { down_svg, up_svg } from "./element-dropdown-menu";

type Props = {
  menuItems: ILink[];
  buttonText: string;
  toggle?: () => void;
};

const DropdownMenu: React.FC<Props> = ({
  menuItems,
  buttonText,
  toggle,
}: Props) => {
  if (!menuItems || menuItems.length < 1) return <></>;
  const { t, i18n } = useTranslation("global");
  const [isSubMenuOpen, setSubMenuOpen] = useState<boolean>(false);

  const toggleSubMenu = () => {
    setSubMenuOpen(!isSubMenuOpen);
  };

  const closeSidebarAndSubMenu = () => {
    if (toggle) toggle();
    setSubMenuOpen(false);
  };

  return (
    <div
      className="m-dropdown-menu"
      onMouseEnter={() => setSubMenuOpen(true)}
      onMouseLeave={() => setSubMenuOpen(false)}
    >
      <button
        className={`dropdown-menu__button navbarlinks__item`}
        onClick={(e) => {
          e.stopPropagation();
          toggleSubMenu();
        }}
        aria-expanded={isSubMenuOpen ? "true" : "false"}
      >
        {buttonText}
        {isSubMenuOpen ? up_svg : down_svg}
      </button>

      <div
        className={`dropdown-menu__items ${isSubMenuOpen ? "dropdown-menu__items--active" : ""}`}
      >
        {menuItems?.map((item, index) => (
          <Link
            key={index}
            activeClassName="dropdown-menu__item--active"
            className="dropdown-menu__item"
            to={`${getSlugWithLang(item?.slug as string, i18n.language as LANGUAGE)}`}
            onClick={closeSidebarAndSubMenu}
          >
            {item.name}
          </Link>
        ))}
      </div>
    </div>
  );
};

export default DropdownMenu;
